import { ChevronLeft } from '@aktiia/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { usePatient } from '../../../contexts';
import { Device } from '../../../enums';
import { useDateRangeText, useTableHeaders, useTableRows } from '../../../features/physiological-data';
import { Button } from '../../common';
import { Table } from '../table';

export const DetailedBpBraceletList = () => {
  const { t } = useTranslation();
  const range = useDateRangeText();
  const rows = useTableRows(Device.BRACELET);
  const headers = useTableHeaders(Device.BRACELET);
  const { visibleTables, toggleVisibleTable } = usePatient();
  const isTableVisible = useMemo(() => {
    return visibleTables.includes(Device.BRACELET);
  }, [visibleTables]);

  if (!rows.length) {
    return <></>;
  }

  return (
    <div id="detailedBpBraceletList">
      <div className="flex items-center">
        <span className="flex typography-heading-2 text-text-primary pt-6 mb-2">
          {t('patient.title.podMeasurements', { range })}
        </span>
        <Button
          text={t(`patient.button.${isTableVisible ? 'hide' : 'show'}`)}
          size="sm"
          type="tertiary"
          className="learn-more-btn pdf-hide ml-auto"
          onClick={() => toggleVisibleTable(Device.BRACELET)}
          leftIcon={
            <ChevronLeft
              className={`chevron scale-75 transition duration-150 ease-out ${
                isTableVisible ? 'rotate-90' : '-rotate-90'
              }`}
            />
          }
        />
      </div>
      <Table
        id="detailedBpBraceletTable"
        className={!isTableVisible ? 'hidden' : ''}
        rows={[...rows].reverse()}
        header={headers}
      />
    </div>
  );
};
